import React from 'react'
import styled from 'styled-components'

const OPTIONS = [
  { value: 'keep', label: 'Keep' },
  { value: 'hide', label: 'Hide' },
  { value: 'delete', label: 'Delete' }
]

const TONES = {
  keep: { bg: '#dcfce7', fg: '#15803d' },
  hide: { bg: '#fef3c7', fg: '#b45309' },
  delete: { bg: '#fdecea', fg: '#b00020' }
}

const TITLES = {
  keep: 'Keep: this file is fine. Stop flagging it and leave it exactly where it is.',
  hide: 'Hide: keep the file but remove it from your file lists and from Guru search. You can unhide it later.',
  delete: 'Delete: remove this file from the Building Passport. You can restore it afterwards from the Upload/Delete history.'
}

const MARK_TITLE = 'Mark for deletion: files synced from SharePoint can’t be deleted here. This only adds it to the SharePoint cleanse list so you can remove it in SharePoint at the source. Nothing is deleted from SharePoint automatically.'

const segTitle = (value, deleteLabel) => {
  if (value === 'delete') return deleteLabel === 'Delete' ? TITLES.delete : MARK_TITLE
  return TITLES[value]
}

const ReviewActionSlider = ({ value, onChange, disabled = false, deleteLabel = 'Delete', tourId = false }) => (
  <Track role='group' aria-label='Choose an action for this file'>
    {OPTIONS.map(o => (
      <Seg
        key={o.value}
        type='button'
        data-tour-id={tourId && o.value === 'hide' ? 'files.review-hide' : undefined}
        $active={value === o.value}
        $tone={o.value}
        aria-pressed={value === o.value}
        disabled={disabled}
        title={segTitle(o.value, deleteLabel)}
        onClick={() => { if (!disabled) onChange(o.value) }}
      >
        {o.value === 'delete' ? deleteLabel : o.label}
      </Seg>
    ))}
  </Track>
)

export default ReviewActionSlider

const Track = styled.div`
  display: inline-flex;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  background: #f8fafc;
  flex-shrink: 0;
`

const Seg = styled.button`
  border: none;
  padding: 5px 13px;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  background: ${({ $active, $tone }) => ($active ? TONES[$tone].bg : 'transparent')};
  color: ${({ $active, $tone }) => ($active ? TONES[$tone].fg : '#64748b')};
  transition: background-color 120ms ease, color 120ms ease;

  & + & { border-left: 1px solid #e2e8f0; }
  &:hover:not(:disabled) { color: ${({ $tone }) => TONES[$tone].fg}; }
  &:disabled { cursor: wait; opacity: 0.6; }
`
